import styled from 'styled-components';

import { color, spacing } from '~/theme';

export const StyledLink = styled.a`
    color: ${color.baseLink};
    cursor: pointer;
    display: inline-flex;
    align-items: baseline;
    margin-bottom: 0;
    padding: ${spacing.spacing1} ${spacing.spacing1} ${spacing.spacing1} ${spacing.spacing0};

    &:visited {
        color: ${color.baseLink};
    }

    &:hover,
    &:focus {
        color: ${color.baseLinkHover};

        svg path {
            fill: ${color.baseLinkHover};
        }
    }

    &:focus {
        box-shadow: 0 0 0 4px ${color.focusBlue};
        outline: 4px solid transparent;
        transition: box-shadow 0.1s ease-in-out;
    }

    &:active {
        color: ${color.baseLinkActive};

        svg path {
            fill: ${color.baseLinkActive};
        }
    }

    svg {
        position: relative;
        top: 0.45rem;
        margin-right: -${spacing.spacing1};

        path {
            fill: ${color.baseLink};
        }
    }
`;

export const StyledBackButton = styled(StyledLink).attrs({
    as: 'button',
})`
    cursor: pointer;
    border: 0;
    background: ${color.palette.white};
    text-decoration: underline;
`;

export const StyledBackErrorButton = styled(StyledBackButton)`
    background: ${color.calloutErrorBG};
    color: ${color.calloutErrorLink};
    margin-bottom: 0;

    &:hover,
    &:focus {
        color: ${color.calloutErrorLinkHover};
    }

    &:active {
        color: ${color.calloutErrorLinkActive};
    }
`;

export default { StyledLink, StyledBackButton, StyledBackErrorButton };
